// react
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

// material ui icons
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

// material ui
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';

// feature-components
import useValidateMeterRow from '@/features/energyxplorer/portfolio/components/meter-drawer/data-integrity/useValidateMeterRow';
// components
import { openDialog } from '@/features/energyxplorer/redux/dataIntegritySlice';

const DataIntegrityButton = ({ row }: { row: Record<string, unknown> }) => {
  const dispatch = useDispatch();
  const handleOpenDataIntegrityDialog = useCallback(
    (row: Record<string, unknown>) => {
      // Dispatch action to open dialog
      dispatch(openDialog(row));
    },
    [dispatch],
  );
  const validateMeter = useValidateMeterRow();
  const warnings = validateMeter(row);
  return (
    <Badge
      overlap="circular"
      badgeContent={
        warnings.length > 0 ? (
          <WarningRoundedIcon sx={{ fontSize: '15px' }} color="warning" />
        ) : null
      }
    >
      <IconButton
        onClick={(e) => {
          handleOpenDataIntegrityDialog(row);
          e.stopPropagation();
        }}
      >
        <TroubleshootIcon sx={{ cursor: 'pointer', marginLeft: 1 }} />
      </IconButton>
    </Badge>
  );
};

export default DataIntegrityButton;
